var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-row",
            { staticClass: "marginTop" },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Tipo de cadastro:", content: _vm.tipo }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data de cadastro:",
                      content: this.dataCadastro
                    }
                  })
                ],
                1
              ),
              _vm.isMa
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: { label: "Bairros:", content: _vm.getBairros }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      !_vm.withOutQualificacao
        ? _c(
            "el-row",
            [
              _c("app-divider", { attrs: { label: "Qualificação" } }),
              _c(
                "el-row",
                { staticClass: "marginTop" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Tipo de informação solicitada:",
                          content: _vm.tipoInformacaoDesejada
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "label" }, [
                      _c("b", { staticClass: "text-color" }, [
                        _vm._v("Justificativa de solicitação:")
                      ]),
                      _c("div", {
                        staticClass: "texto marginTop text-color",
                        domProps: { innerHTML: _vm._s(_vm.getJustificativa) }
                      })
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dc4faf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dc4faf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacaoDesejada.vue
// module id = null
// module chunks = 